import _classCallCheck from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Component } from "react";
import { Result, Results } from "@elastic/react-search-ui-views";
import { withSearch } from "..";
import { Result as ResultContainer } from ".";

function getRaw(result, value) {
  if (!result[value] || !result[value].raw) return;
  return result[value].raw;
}

export var ResultsContainer = /*#__PURE__*/function (_Component) {
  _inherits(ResultsContainer, _Component);

  var _super = _createSuper(ResultsContainer);

  function ResultsContainer() {
    _classCallCheck(this, ResultsContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ResultsContainer, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          clickThroughTags = _a.clickThroughTags,
          resultView = _a.resultView,
          results = _a.results,
          shouldTrackClickThrough = _a.shouldTrackClickThrough,
          titleField = _a.titleField,
          urlField = _a.urlField,
          thumbnailField = _a.thumbnailField,
          view = _a.view,
          rest = __rest(_a, ["className", "clickThroughTags", "resultView", "results", "shouldTrackClickThrough", "titleField", "urlField", "thumbnailField", "view"]);

      var View = view || Results;
      var ResultView = resultView || Result;
      var children = results.map(function (result) {
        return React.createElement(ResultContainer, {
          key: "result-".concat(getRaw(result, "id")),
          titleField: titleField,
          urlField: urlField,
          thumbnailField: thumbnailField,
          view: ResultView,
          shouldTrackClickThrough: shouldTrackClickThrough,
          clickThroughTags: clickThroughTags,
          result: result
        });
      });
      var viewProps = Object.assign({
        className: className,
        children: children
      }, rest);
      return React.createElement(View, Object.assign({}, viewProps));
    }
  }]);

  return ResultsContainer;
}(Component);
ResultsContainer.defaultProps = {
  clickThroughTags: [],
  shouldTrackClickThrough: true
};
export default withSearch(function (_ref) {
  var results = _ref.results;
  return {
    results: results
  };
})(ResultsContainer);